import {
  observable,
  computed,
  action,
} from 'mobx';
import { NotificationsService, INotification } from '../../application/services/NotificationsService';
import { NOTIFICATION_GROUP, NOTIFICATION_TYPE } from '../../constants/Notifications';

interface INotificationsViewData {
  notifications: INotification[];
}

export default class NotificationsViewController {
  private messagesService: NotificationsService;

  @observable notificationGroup: NOTIFICATION_GROUP;

  @observable notificationType: NOTIFICATION_TYPE;

  constructor(config: {
    notificationsService: NotificationsService,
  }) {
    this.messagesService = config.notificationsService;
  }

  @computed
  get data(): INotificationsViewData {
    const { getNotificationsByGroup } = this.messagesService;

    return {
      notifications: this.notificationGroup ? getNotificationsByGroup(this.notificationGroup, this.notificationType) : [],
    };
  }

  @action
  public load = async (group: NOTIFICATION_GROUP, type?: NOTIFICATION_TYPE): Promise<void> => {
    await this.messagesService.loadTranslations();
    this.setMessageFilters(group, type);
  };

  @action
  setMessageFilters = (group: NOTIFICATION_GROUP, type?: NOTIFICATION_TYPE): void => {
    this.notificationGroup = group;
    this.notificationType = type;
  };
}
